import { serverEnv } from "../../configs/config";

const getRedirectUri = serverEnv => {
  if (serverEnv === "DEV") return "https://dev.efficiencesell.fr/";
  if (serverEnv === "STAGING") return "https://staging.efficiencesell.fr/";
  if (serverEnv === "PROD") {
    const currentURL = window.location.hostname;
    const redirectURI = `https://${currentURL}/`;
    return redirectURI;
  }
  return "https://efficiencesell-front-dev.herokuapp.com/";
};

export const msalConfig = {
    auth: {
      clientId: "c935f358-59a1-4009-9a26-a7e6d432b73c",
      authority: "https://login.microsoftonline.com/80534926-8493-4ede-be6a-ed1707a835e8", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
      redirectUri: getRedirectUri(serverEnv),
    },
    cache: {
      cacheLocation: "sessionStorage", // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
  };

  // Add scopes here for ID token to be used at Microsoft identity platform endpoints.
  export const loginRequest = {
   scopes: ["User.Read"]
  };

  // Add the endpoints here for Microsoft Graph API services you'd like to use.
  export const graphConfig = {
      graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
  };



// WEBPACK FOOTER //
// src/components/login/microsoftAuthConfig.js